import { types as t, getParent, flow } from 'mobx-state-tree';

import { validateEmail } from '@utils/validators';

import { withEnv } from 'models/withEnv';

const NotifyEmail = t
  .model('NotifyEmail', {
    value: t.string,
    valid: true,
  })
  .views((self) => ({
    get parent() {
      return getParent(self, 2);
    },
  }))
  .actions((self) => ({
    setValue(value) {
      self.value = value;
    },
    onBlur() {
      self.valid = validateEmail(self.value) || self.value === '';
      if (!self.parent.hasEmpty && !self.parent.hasInvalid) {
        let emails = [...self.parent.notifyEmails];
        emails.push({ value: '' });
        self.parent.setEmails(emails);
      }
      if (self.parent.notifyEmails.filter((e) => e.value === '').length > 1 && self.value === '') {
        let emails = [...self.parent.notifyEmails.filter((item) => item !== self)];
        self.parent.setEmails(emails);
      }
    },
  }));
export const KjarniSettings = t
  .model('KjarniSettings', {
    notifyEmails: t.array(NotifyEmail),
  })
  .views(withEnv)
  .views((self) => ({
    get hasEmpty() {
      return self.notifyEmails.some((e) => e.value === '');
    },
    get hasInvalid() {
      return self.notifyEmails.some((e) => !e.valid);
    },
  }))
  .actions((self) => ({
    afterCreate() {
      self.getEmails();
    },
    setEmails(emails) {
      self.notifyEmails = emails;
    },
    getEmails: flow(function* () {
      const res = yield self.env.api.integrations.kjarniEmails();
      if (!res.error) {
        let emails = [''];
        if (res.data.emails) {
          emails = res.data.emails.split(',');
          if (emails[emails.length - 1] !== '') {
            emails.push('');
          }
        }
        self.notifyEmails = emails.map((e) => ({
          value: e,
          valid: validateEmail(e) || e === '',
        }));
      }
    }),
    submitEmails: flow(function* () {
      const emails = self.notifyEmails
        .map((e) => e.value)
        .filter(Boolean)
        .join(',');
      const res = yield self.env.api.integrations.kjarniSubmitEmails(emails);
      if (res.status === 200) {
        self.env.showSuccess(self.env.t('integrations.kjarni.settings.save.success'));
      } else {
        self.env.showError(self.env.t('integrations.kjarni.settings.save.error'));
      }
      return res;
    }),
  }));
